import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-subtradechannel-dropdown',
  templateUrl: './SubtradeChannelDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => SubtradeChannelDropdownComponent)}]
})
export class SubtradeChannelDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }

    ngOnInit(): void {
    }

    public load(){

        var filter: filters.SubtradeChannelFilter = {};
        this.domainDataService.getSubtradeChannels(filter).subscribe(x=> this.onGetSubtradeChannelsDone(x));
    }
    
    onGetSubtradeChannelsDone(items: ent.SubtradeChannel[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        this.value = this.selectedID;
    }

}